module.exports = __webpack_public_path__ + "static/media/meanreverting.4a529aad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/SVGs/meanreverting.svg
// module id = 184
// module chunks = 0